export const GRAPHQL_ROOT_URL = import.meta.env.VITE_DEFAULT_GRAPHQL_ROOT_URL;
